import React from 'react';

export default function VersiHistori() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Versi & Histori Dokumen</h1>
      <p className="text-gray-500">Halaman Versi & Histori Dokumen</p>
    </div>
  );
}
